import BaseModule from "@core/modules/base-module/base-module";
import NewsCard from "@core/components/cards/news-card/news-card";

const highlightedNewsArticle = new BaseModule();
highlightedNewsArticle.name = "highlighted-news-article";
highlightedNewsArticle.init((that)=>{
  const card=new NewsCard(that.elements);
  card.init();
});
